// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_2qPhi","logo":"index_logo_1Djea","logoAnimate":"index_logoAnimate_2PUEB","mainLogo":"index_mainLogo_2EUfV","version":"index_version_2Jy63"};